import { useImageUploader } from '@hooks/useImageKit'
import styles from '@styles/CrudProduct.module.css'
import PropTypes from 'prop-types'

const ProductTable = ({ products, onDelete, onEdit, onToggleStatus, formatPrice, darkMode }) => {
    const { handleDeleteImage } = useImageUploader()
    return (
    <div className={styles.tableContainer}>
      <table className={`${styles.table} ${darkMode ? styles.dark : ''}`}>
        <thead>
          <tr>
            <th className={styles.tableHeader}>ID</th>
            <th className={styles.tableHeader}>Imagen</th>
            <th className={styles.tableHeader}>Marca</th>
            <th className={styles.tableHeader}>Categoría</th>
            <th className={styles.tableHeader}>Referencia</th>
            <th className={styles.tableHeader}>Precio</th>
            <th className={styles.tableHeader}>Estado</th>
            <th className={styles.tableHeader}>Acciones</th>
          </tr>
        </thead>
          <tbody>
            {products.map(product => (
              <tr className={styles.tableRow} key={product.id}>
                <td className={styles.tableCell} data-label='ID'>{product.id}</td>
                <td className={styles.tableCell} data-label='Imagen'>
                  <img
                    src={product.image.url || product.image}
                    alt={product.reference}
                    className={styles.productImage}
                  />
                </td>
                <td className={styles.tableCell} data-label='Marca'>{product.brand}</td>
                <td className={styles.tableCell} data-label='Categoría'>{product.category}</td>
                <td className={styles.tableCell} data-label='Referencia'>{product.reference}</td>
                <td className={styles.tableCell} data-label='Precio'>{formatPrice(product.price)}</td>
                <td className={styles.tableCell} data-label='Estado'>
                  <button
                    onClick={() => onToggleStatus(product.id, product.active)}
                    className={
                      product.active ? styles.activeButton : styles.inactiveButton
                    }
                  >
                    {product.active ? 'Activo' : 'Inactivo'}
                  </button>
                </td>
                <td className={styles.tableCell} data-label='Acciones'>
                  <button
                    onClick={async () => {
                      await onDelete(product.id);
                      await handleDeleteImage(product.image.fileId);
                    }}
                    className={styles.deleteButton}
                  >
                    Eliminar
                  </button>
                  <button
                    onClick={() => onEdit(product)}
                    className={styles.updateButton}
                  >
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
  )
}

ProductTable.propTypes = {
  products: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onToggleStatus: PropTypes.func.isRequired,
  formatPrice: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
}

export default ProductTable
